import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "CANCEL_SCHEDULED_ORDER_FOB_" }
);

export interface CancelScheduledOrderFOBState extends IState {}

const INITIAL_STATE: CancelScheduledOrderFOBState = {
  loading: false,
  error: null,
};

const request = (state: CancelScheduledOrderFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: CancelScheduledOrderFOBState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: CancelScheduledOrderFOBState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const cancelScheduledOrderFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const CancelScheduledOrderFOBTypes = Types;
export const CancelScheduledOrderFOBActions = Creators;
